﻿import {$, $$, hide} from "@/Utils";
import {updateAddressFields, queryAddresses} from "@/AddressSearchCommon";

/* Manual address search from classificators for LT */
export function initManualAddressSearch() {
    $$(".manual-address-container").forEach(addressComponent => {
        const addressField = addressComponent?.querySelector(".manual-address-search-input") as HTMLInputElement;

        if (!addressField) {
            return;
        }
        const addressList = addressComponent.querySelector(".autocomplete-list") as HTMLElement;

        let timeout: number = null;

        const addressFieldInputListener = (e: Event) => {
            hide(addressList);
            clearTimeout(timeout);
            const addressSearchField = e.currentTarget as HTMLInputElement;
            const searchString = addressSearchField.value;

            // clear address fields if search has been removed
            if (!searchString.length) {
                updateAddressFields(addressComponent);
            }
            // do not search under 3 chars
            if (searchString.length < 3) {
                return;
            }

            timeout = window.setTimeout(() => queryAddresses(searchString, addressComponent, false, true), 750);
        }

        addressField.addDataBoundEventListener("input", addressFieldInputListener);


        const addressListClickListener = (e: Event) => {
            let target = e.target as HTMLElement;
            if (!target.hasAttribute("data-address")) {
                target = target.parentElement; //<mark> click
            }

            if (!target) return;
            addressField.value = target.getAttribute("data-formatted-address");
            updateAddressFields(addressComponent, target).then();
            hide(addressList);
        }

        addressList.addDataBoundEventListener("click", addressListClickListener);
    })
}
